import MuiOutlinedInput from '@material-ui/core/OutlinedInput';

export default MuiOutlinedInput;
